import AnalyticsEvents_V2 from '../analyticsGA4'
import { PortalProducts } from '../types/analytics.type'

import { DashboardEvents } from './dashboardEvents.types'

class DashboardAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.DASHBOARD)
  }

  public handleHeaderTopMenuClick(name: string, product?: string): void {
    switch (name) {
      case 'hamburger':
        this.logEvent({ event: DashboardEvents.CLICKED_MENU_HAMBURGER })
        break
      case 'BurgerMenuClick':
        this.logEvent({ event: `${DashboardEvents.CLICKED_MENU_HAMBURGER_PRODUCTS}_${product}` })
        break
      case 'search':
        this.logEvent({ event: DashboardEvents.CLICKED_MENU_SEARCH })
        break
      case 'logo':
        this.logEvent({ event: DashboardEvents.CLICKED_HOM_LOGO })
        break
      default:
        break
    }
  }

  public handleMobileBottomMenuClick(name: string): void {
    switch (name) {
      case 'home':
        this.logEvent({ event: DashboardEvents.CLICKED_BOTTOM_MOBILE_MENU_HOME })
        break
      case 'league':
        this.logEvent({ event: DashboardEvents.CLICKED_BOTTOM_MOBILE_MENU_LEAGUE })
        break
      case 'statistics':
        this.logEvent({ event: DashboardEvents.CLICKED_BOTTOM_MOBILE_MENU_STATISTICS })
        break
      case 'chat':
        this.logEvent({ event: DashboardEvents.CLICKED_BOTTOM_MOBILE_MENU_CHAT })
        break
      case 'all-math':
        this.logEvent({ event: DashboardEvents.CLICKED_BOTTOM_MOBILE_ALL_MATH })
        break
      default:
        break
    }
  }

  public handleDashboardItemViewClick(name: string): void {
    switch (name) {
      case 'league':
        this.logEvent({ event: DashboardEvents.CLICKED_DASHBOARD_LEAGUE_VIEW })
        break
      case 'stats':
        this.logEvent({ event: DashboardEvents.CLICKED_DASHBOARD_STATS_VIEW })
        break
      case 'games':
        this.logEvent({ event: DashboardEvents.CLICKED_DASHBOARD_GAMES_VIEW })
        break
      case 'all-math':
        this.logEvent({ event: DashboardEvents.CLICKED_DASHBOARD_ALL_MATH_VIEW })
        break
      case 'home':
        this.logEvent({ event: DashboardEvents.CLICKED_DASHBOARD_HOME_VIEW })
        break
      default:
        break
    }
  }

  public logClickOnLatestLearning(type: string, name: string): void {
    this.logEvent({
      event: DashboardEvents.CLICKED_DASHBOARD_LATEST_LEARNING,
      type,
      name,
    })
  }
}

const dashboardAnalytics = new DashboardAnalytics()

export default dashboardAnalytics
